import React from "react";
import styles from "./projects.module.css";

export default function Projects() {

    return (
        <React.Fragment>
            <div id="projects" className={styles.container}>
                <p
                    className={styles.project}
                >
                    Coming Soon!
                </p>
            </div>
        </React.Fragment>
    );
}
